import React from "react";
import { Style } from "./style";
import { InterphoneViewProps } from "./type";
import {} from "../../recoil/interphone";
import Spinner from "../../components/Spinner";
import {
  INTERPHONE_STATUS_CALLING,
  INTERPHONE_STATUS_NONE,
  INTERPHONE_STATUS_RECEIVER_WAIT,
  INTERPHONE_STATUS_SENDER_WAIT,
} from "../../controller/InterphoneController";
import { langText } from "../../recoil/lang";

const InterphoneView = ({ hook }: InterphoneViewProps) => {
  return (
    <Style>
      <div className="wrap">
        <div className="callStatusWrap">
          <h2>{hook.interphoneArea || ""}</h2>
          <h4>{hook.getInterphoneTitle()}</h4>
          {(hook.interphoneFlag.status === INTERPHONE_STATUS_NONE ||
            hook.interphoneFlag.status === INTERPHONE_STATUS_CALLING) && (
            <h4 className="callTime">{hook.getCallingTime()}</h4>
          )}
          {(hook.interphoneFlag.status === INTERPHONE_STATUS_SENDER_WAIT ||
            hook.interphoneFlag.status === INTERPHONE_STATUS_RECEIVER_WAIT) && (
            <Spinner size={100} />
          )}
        </div>
        <div className="footerWrap">
          <div className="buttonWrap">
            {hook.interphoneFlag.status === INTERPHONE_STATUS_RECEIVER_WAIT && (
              <button onClick={hook.acceptVoiceChat}>
                <p>{langText.interphone_call[hook.lang]}</p>
                <img
                  className="call"
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_phone.svg`}
                  alt="phone"
                />
              </button>
            )}
            <button onClick={hook.handleLeave}>
              <p>
                {hook.interphoneFlag.status === INTERPHONE_STATUS_RECEIVER_WAIT
                  ? langText.interphone_decline[hook.lang]
                  : langText.interphone_end[hook.lang]}
              </p>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_phone.svg`}
                alt="phone"
              />
            </button>
          </div>
          {<p className="hotelName">{hook.deviceArea?.name || ""}</p>}
        </div>
      </div>
    </Style>
  );
};
export default InterphoneView;
